/* eslint-disable no-new */

import { isFunction, isUndefined, isEmpty } from 'lodash';

/**
 * color marker
 *
 * @param {Number} type
 */
function pinSymbol(type) {
  switch (type) {
    case 1:
    default:
      return 'http://maps.google.com/mapfiles/ms/icons/green.png';
    case 2:
      return 'http://maps.google.com/mapfiles/ms/icons/yellow.png';
    case 3:
      return 'http://maps.google.com/mapfiles/ms/icons/purple.png';
    case 4:
      return 'http://maps.google.com/mapfiles/ms/icons/red.png';
  }
}

/**
 * create maps.
 *
 * @param {Object} map
 * @param {Object} options
 */
export function GoogleMaps(map, options) {
  const center = { lat: -19.9084242, lng: -43.916540900000008 };

  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition((position) => {
      center.lat = position.coords.latitude;
      center.lng = position.coords.longitude;
    });
  }

  const googleMaps = document.createElement('script');

  const createMaps = () =>
    new window.google.maps.Map(map.current, {
      zoom: 12,
      center,
      mapTypeId: 'satellite',
    });

  const drawingManager = () =>
    new window.google.maps.drawing.DrawingManager({
      drawingMode: window.google.maps.drawing.OverlayType.POLYGON,
      drawingControl: true,
      drawingControlOptions: {
        position: window.google.maps.ControlPosition.TOP_CENTER,
        drawingModes: [window.google.maps.drawing.OverlayType.POLYGON],
      },
      polygonOptions: {
        fillColor: '#ff6666',
        strokeWeight: 3,
        editable: true,
      },
    });

  googleMaps.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}&libraries=places,drawing`;

  window.document.body.appendChild(googleMaps);
  googleMaps.addEventListener('load', () => {
    map.current = createMaps();

    // change drawing in map
    if (!isUndefined(options) && options.drawing) {
      options.drawing.current = drawingManager();

      options.drawing.current.setMap(map.current);

      window.google.maps.event.addListener(
        options.drawing.current,
        'overlaycomplete',
        (event) => {
          event.overlay.set('editable', false);
          options.drawing.current.setMap(null);
          options.callbackDrawing(event);
        }
      );
    }
  });
}

/**
 * set markers ans polyline in map.
 *
 * @param {Object} maps
 * @param {Array} markers
 * @param {Boolean} polyline
 */
export function Markers(maps, markers, polyline = true, infoWindow) {
  let mapsPolyline;

  const flightPlanCoordinates = markers.map(({ lat, lng }) => ({
    lat,
    lng,
  }));

  const info = new window.google.maps.InfoWindow({
    content: '',
  });

  const mapsMarkers = markers.map((marker) => {
    const { lat, lng, label = '' } = marker;

    const google = new window.google.maps.Marker({
      position: { lat, lng },
      label: {
        text: label,
        color: '#000',
        fontSize: '10px',
      },
      map: maps.current,
      zoom: 12,
      icon: pinSymbol(marker.type),
    });

    if (isFunction(infoWindow)) {
      google.addListener('click', async () => {
        const result = await infoWindow(marker);

        await info.setContent(`<div class="card">${result}</div>`);
        await info.open(maps.current, google);
      });
    }

    return google;
  });

  // set polyline in map.
  if (polyline) {
    mapsPolyline = new window.google.maps.Polyline({
      path: flightPlanCoordinates,
      geodesic: true,
      strokeColor: '#FF0000',
      strokeOpacity: 1.0,
      strokeWeight: 2,
      map: maps.current,
    });
  }

  maps.current.setCenter({
    lat: flightPlanCoordinates[0].lat,
    lng: flightPlanCoordinates[0].lng,
  });

  return { markers: mapsMarkers, polyline: mapsPolyline };
}

/**
 * remove markers and polyline
 *
 * @param {Array} markers
 * @param {Object} polyline
 */
export function MarkersRemove(markers, polyline) {
  markers.map((marker) => {
    marker.setMap(null);
  });

  if (polyline) {
    polyline.setMap(null);
  }
}

/**
 * drawing tools enabled
 *
 * @param {Object} maps
 */
export function DrawingManager(maps) {
  new window.google.maps.drawing.DrawingManager({
    drawingMode: window.google.maps.drawing.OverlayType.MARKER,
    drawingControl: true,
    drawingControlOptions: {
      position: window.google.maps.ControlPosition.TOP_CENTER,
      drawingModes: [window.google.maps.drawing.OverlayType.POLYGON],
    },
    markerOptions: {
      icon:
        'https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png',
    },
    circleOptions: {
      fillColor: '#ffff00',
      fillOpacity: 1,
      strokeWeight: 5,
      clickable: false,
      editable: true,
      zIndex: 1,
    },
  }).setMap(maps.current);
}

/**
 * change zoom
 *
 * @param {Object} map
 * @param {Number} zoom
 * @param {Object} center
 */
export function googleZoom(map, zoom, center) {
  if (!isEmpty(center)) {
    map.current.setCenter(center);
  }

  map.current.setZoom(zoom);
}

/**
 * set polygon in map
 *
 * @param {*} maps
 * @param {*} polygons
 */
export function Polygon(maps, polygons) {
  new window.google.maps.Polygon({
    paths: polygons,
    fillColor: '#ff6666',
    strokeWeight: 3,
    editable: true,
    map: maps.current,
  });
}
